<template>
  <div class="eBook">
    <img src="@/assets/images/detail/mine_bgg.png" alt="" class="top_bg" />

    <div class="navbar" v-if="scrollPosition == 0">
      <span>图书详情</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>

    <div class="navbar1" v-if="scrollPosition != 0">
      <div class="navbar1-box">
        <span>图书详情</span>
        <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
      </div>
    </div>
    <div class="content" v-if="detailInfo.picUrl">
      <div class="book_detail d-f ai-c">
        <img :src="detailInfo.picUrl" alt="" class="book_img" />
        <div>
          <div class="title">{{ detailInfo.name }}</div>
          <div class="detail d-f fxd-c">
            <span>作者：{{ detailInfo.author }} </span>
            <span>ISBN：{{ detailInfo.isbn }}</span>
            <span>出版社：{{ detailInfo.publisher }}</span>
            <span v-if="type == 1">出版时间：{{ detailInfo.publishTime }}</span>
            <span v-if="!type">浏览量：{{ detailInfo.pageViewNum }}</span>
          </div>
        </div>
      </div>

      <div class="d-f jc-sb ai-c btns" v-if="!type && detailInfo">
        <div class="btn" @click="addBook" v-if="!detailInfo.isBookShelf">加入书架</div>
        <div class="btn btn_right" @click="readBook(detailInfo.bookUrl)">立即阅读</div>
      </div>
      <div class="segmentation"></div>
      <div v-if="!type">
        <div class="common_title">内容简介</div>
        <div class="intro_content" v-html="detail"></div>
      </div>
      <div v-if="type == 1">
        <div class="common_title">推荐语</div>
        <div class="intro_content" v-html="remark"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBookDetails, addBookShelf } from '@/api/book'
import { getToken, getVenueToken } from '@/utils/auth'
import { format } from '@/utils/DES.js'

export default {
  name: 'eBook',
  data() {
    return {
      detailInfo: {},
      type: '',
      scrollPosition: 0,
      detail: '',
      remark: '',
    }
  },
  methods: {
    back() {
      // this.$myUni.postMessage({
      //   data: {
      //     methodsName: 'UNIBack',
      //   },
      // })
      this.$myUni.navigateBack({
        delta: 1,
      })
    },
    getDetail() {
      getBookDetails(this.id).then((res) => {
        this.detailInfo = res.result
        if (this.detailInfo.detail) {
          this.detail = format(this.detailInfo.detail)
        }
        if (this.detailInfo.remark) {
          this.remark = format(this.detailInfo.remark)
        }
        console.log('remark======>', this.remark)
      })
    },
    readBook(url) {
      if (!getToken()) {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIPage',
            data: {
              id: this.id,
              url: '/detail/eBook',
              needLocation: false,
            },
          },
        })
        return
      }

      window.location.href = url
    },
    addBook() {
      if (!getToken()) {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIPage',
            data: {
              id: this.id,
              url: '/detail/eBook',
              needLocation: false,
            },
          },
        })
        return
      }
      addBookShelf(this.id).then((res) => {
        if (res.code == 2000) {
          this.$cue.toast('加入书架成功')
          this.getDetail()
        }
      })
    },
    scrollToTop() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log(scrollTop)
      this.scrollPosition = scrollTop
    },
  },
  mounted() {
    const data = JSON.parse(this.$route.query.params)
    this.id = data.id
    if (data.type) {
      this.type = data.type
    }
    console.log(this.type)
    // this.id = 2
    this.getDetail()
    window.addEventListener('scroll', this.scrollToTop)
  },
}
</script>
<style lang="scss" scoped>
.eBook {
  width: 100%;
  height: 100vh;
  // background: #f4fcfc;
  background: #fff;
  position: relative;

  .tag_item {
    font-size: 0.6rem;
    padding: 0 0.3rem;
    color: #47988aff;
    height: 0.9rem;
    line-height: 0.9rem;
    background: rgba(71, 152, 138, 0.15);
    border-radius: 2px;
    margin: 0.3rem 0.4rem 0.4rem 0;
  }
  .top_bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 12rem;
  }
  .navbar {
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: env(safe-area-inset-top);
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    // background: #ffffff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .navbar1 {
    width: 100%;
    height: 88px;
    position: fixed;
    z-index: 9999;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #ffffff;
    .navbar1-box {
      margin-top: 44px;
      overflow: hidden;
    }
    .back {
      margin-top: 44px;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 84px);
    position: absolute;
    top: 84px;
    left: 0;
    // padding: 0.7rem 0.6rem 0 0.6rem;
    padding-top: 0.7rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .book_detail {
      padding: 0 0.6rem;
      margin-bottom: 1rem;

      .book_img {
        width: 5.4rem;
        height: 7.2rem;
        border-radius: 0.5rem;
        margin-right: 1rem;
      }
      .title {
        font-size: 0.9rem;
        font-weight: 600;
        color: #212121;
        line-height: 1.4rem;
        margin-bottom: 0.6rem;
      }
      .detail {
        font-size: 0.6rem;
        color: #666666;
        line-height: 1.1rem;
      }
    }
    .btns {
      padding: 0 0.6rem;
      margin: 0 0 0.8rem 0;
      .btn {
        box-sizing: border-box;
        width: calc(50% - 0.38rem);
        text-align: center;
        height: 1.7rem;
        line-height: 1.7rem;
        border-radius: 0.4rem;
        border: 1px solid #a97048;
        font-size: 0.7rem;
        color: #a97048;
      }
      .btn_right {
        background: #a97048;
        color: #fff;
      }
      .isBookShelf {
        width: 100%;
      }
    }
    .segmentation {
      width: 100%;
      height: 0.3rem;
      // background: #ecf3f3;
      background: #f4f4f4;
    }
    // .information {
    //   margin-bottom: 1.2rem;
    //   .profile_photo {
    //     width: 3rem;
    //     height: 3rem;
    //     margin-right: 0.55rem;
    //   }
    //   .name {
    //     font-size: 0.9rem;
    //     font-weight: 600;
    //     color: #212121;
    //     line-height: 1.4rem;
    //   }
    //   .address {
    //     font-size: 0.65rem;
    //     color: #666666;
    //     line-height: 0.9rem;
    //   }
    //   .right_total {
    //     height: 100%;
    //     font-size: 0.6rem;
    //     color: #666666;
    //     line-height: 0.8rem;
    //     .attention {
    //       margin-top: 0.85rem;
    //       font-size: 0.5rem;
    //       color: #ffffff;
    //       line-height: 0.6rem;
    //       padding: 0 0.4rem;
    //       height: 1.1rem;
    //       line-height: 1.1rem;
    //       background: rgba(71, 152, 138, 1);
    //       border-radius: 0.7rem;
    //       .add_icon {
    //         width: 0.5rem;
    //         height: 0.5rem;
    //         margin-right: 4px;
    //       }
    //     }
    //   }
    // }
    .common_title {
      padding: 0 0.6rem;

      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
      margin-bottom: 0.6rem;
      margin-top: 1rem;
    }
    .intro_content {
      padding: 0 0.6rem;

      font-size: 0.7rem;
      color: #666666;
      line-height: 1rem;
      margin-bottom: 1.2rem;
    }
    .project_img {
      width: 6.4rem;
      height: 4.8rem;
      border-radius: 0.5rem;
      margin-right: 0.6rem;
    }
    .title {
      font-size: 0.7rem;
      font-weight: 600;
      color: #212121;
      line-height: 1rem;
    }
    .project_content {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
  }
}
</style>
